import { Typography } from '@material-ui/core';
import { useSnackbar } from 'notistack';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { download, getLastDate } from '../../../services/documento/DocumentoService';
import BotaoDownload from '../botaoDownload';
import useStyles from './styles';

const maxWordsCount = 255; //Regra na issue 85

const UltimosDocumentosAcessados = (props) => {

  const { documentos } = props;
  const { enqueueSnackbar } = useSnackbar();
  const classes = useStyles();

  const handleDownload = async (documentoSelecionado) => {
    const { id, nome, dam, formato } = documentoSelecionado;
    try {
      const response = await download(id);
      console.log(response)
      const url = URL.createObjectURL(new Blob([response.data]));
      const a = document.createElement('a');
      a.href = url;
      document.body.appendChild(a);
      a.download = `${nome}.${formato}`;
      a.click();
    } catch (e) {
      enqueueSnackbar('Ocorreu um erro ao realizar o download do arquivo', { variant: 'error' })
    }
  }

  const handleNome = (nom) => {
    if(nom.length > maxWordsCount) {
      return nom.slice(0,maxWordsCount) + "…";
    }
    return nom;
  }

  return (
    <>
      <Typography className={classes.titulo}>Últimos acessados</Typography>
      <div className={classes.retanguloContainer}>
        {documentos.map((documento) => (
          <div key={documento.id} style={{ position: 'relative', width: '266px' }}>
            <BotaoDownload large onClickHandle={() => handleDownload(documento)} favorito={documento.favorito} fixadoEmReuniao={documento.fixadoEmReuniao}>
              <Typography className={classes.nomeArquivo}>{handleNome(documento.nome)}</Typography>
              <Typography className={classes.informacoesAdicionais}>Aberto {getLastDate(documento.dataUltimoAcesso)} - {documento.formato}</Typography>
            </BotaoDownload>
          </div>
        ))}
      </div>
    </>
  )
}

export default UltimosDocumentosAcessados;

UltimosDocumentosAcessados.propTypes = {
  documentos: PropTypes.array.isRequired,
};
